/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSmallerEq } from '../../factoriesAny.js';
export var smallerEqDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createSmallerEq
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSmallerEq.generated.js
// module id = 375
// module chunks = 2